class OurPhilosophy extends HTMLElement {
    constructor() {
      super();
      this.items = [];
    }

    connectedCallback() {
      this.initAccordion();
    }

    disconnectedCallback() {
      this.destroyAccordion();
    }

    initAccordion() {
      this.items = this.querySelectorAll('.philosophy-accordion-item');

      this.items.forEach((item) => {
        const button = item.querySelector('.philosophy-accordion-button');

        if (!button) return;

        button.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          const accordion = item.closest('.section-our-philosophy-accordion');

          /*
           * Close other items in the same column
           */
          if (accordion) {
            accordion
              .querySelectorAll('.philosophy-accordion-item.is-open')
              .forEach((openItem) => {
                if (openItem !== item) {
                  this.closeItem(openItem);
                }
              });
          }

          /*
           * Toggle current item
           */
          if (isOpen) {
            this.closeItem(item);
          } else {
            this.openItem(item);
          }
        });
      });
    }

    openItem(item) {
      const button = item.querySelector('.philosophy-accordion-button');
      const content = item.querySelector('.philosophy-accordion-content');

      if (!button || !content) return;

      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');

      /*
       * Set actual height for smooth animation
       */
      content.style.height = content.scrollHeight + 'px';
    }

    closeItem(item) {
      const button = item.querySelector('.philosophy-accordion-button');
      const content = item.querySelector('.philosophy-accordion-content');

      if (!button || !content) return;

      /*
       * If height is auto/empty, first set current height
       */
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        content.style.height = '0px';
      });
    }

    destroyAccordion() {
      this.items = [];
    }
  }

  if (!customElements.get('our-philosophy')) {
    customElements.define('our-philosophy', OurPhilosophy);
  }